module.exports = __webpack_public_path__ + "media/lmb_pano.895c10ef.mp4";